import React from 'react';

export default
<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <rect fill="currentColor" x="0" y="0" width="64" height="8"/>
    <rect fill="currentColor" x="0" y="18" width="64" height="4"/>
    <rect fill="currentColor" x="0" y="0" width="4" height="64"/>
    <rect fill="currentColor" x="60" y="0" width="4" height="64"/>
    <rect fill="currentColor" x="40" y="0" width="4" height="64"/>
    <rect fill="currentColor" x="20" y="0" width="4" height="64"/>
    <rect fill="currentColor" x="0" y="32" width="64" height="4"/>
    <rect fill="currentColor" x="0" y="46" width="64" height="4"/>
    <rect fill="currentColor" x="0" y="60" width="64" height="4"/>
</g>
